import { MinimalLayout } from '@/components/layouts/MinimalLayout'
import { EditorNavbar } from '@/components/nav/EditorNavbar'
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from '@/components/ui/resizable'
import { ReadOnlyBanner } from '@/components/banners/ReadOnlyBanner'
import { Spinner } from '@/components/ui/spinner'
import { CADVersionProcessingHelper } from '../CADPage/components/CadVersionProcessingHelper'

import { Documents } from './components/Documents'
import { TableOfContents } from './components/TableOfContents'
import { DocumentPageToolbar } from './components/DocumentPageToolbar/DocumentPageToolbar'
import { DocPageContainer } from '@/components/layouts/DocPageContainer'
import { useDocumentState, MAIN_DOCUMENT_CONTAINER_TOP_PADDING } from '@/state'
import Comments from './components/Documents/Comments'
import { OperationThemePreviews } from './components/Documents/ThemePreviews/OperationThemePreviews'
import { usePreloadImages } from '@/utils/hooks/usePreloadImages'
import { useComments } from './hooks'
import { useEnableTimeTravel } from '@/lib/timeTravel/useEnableTimeTravel'
import { useEnabledTemplateAttributesMultiSelect } from '@/pages/DocumentPage/features/templateAttributesMultiSelect/useEnabledTemplateAttributesMultiSelect'
import { useCADVersionProcessing } from '@/services/hooks/cad_versions'
import { useDocumentPageQuery } from '@/pages/DocumentPage/queries'

export const DocumentPage = () => {
  useEnableTimeTravel()
  useEnabledTemplateAttributesMultiSelect()

  const {
    isLoading,
    isComplete,
    isProcessing,
    data: cadVersionProcess,
  } = useCADVersionProcessing({ pollDocumentVersions: true })

  const commentsEnabled = useComments()
  const pageTemplatesEnabled = useDocumentState(
    (state) => state.pageTemplatesEnabled,
  )
  usePreloadImages()

  const { data: docPage } = useDocumentPageQuery()
  const documentName = docPage.doc?.name

  return (
    <MinimalLayout
      title={`${documentName ? `${documentName} -` : ''} Quarter20 Document`}
    >
      <EditorNavbar active="document" />
      <ReadOnlyBanner />
      <DocPageContainer>
        {isLoading && <Spinner />}
        {isComplete && (
          <ResizablePanelGroup direction="horizontal">
            <ResizablePanel defaultSize={21} minSize={15} maxSize={40}>
              <TableOfContents />
            </ResizablePanel>
            <ResizableHandle />
            <ResizablePanel
              className="relative"
              style={{ paddingTop: MAIN_DOCUMENT_CONTAINER_TOP_PADDING }}
            >
              <DocumentPageToolbar />
              <Documents />
            </ResizablePanel>
            {pageTemplatesEnabled && (
              <>
                <ResizablePanel
                  className="relative min-w-[300px]"
                  defaultSize={16}
                  minSize={16}
                  maxSize={16}
                >
                  <OperationThemePreviews />
                </ResizablePanel>
              </>
            )}
            {commentsEnabled && (
              <>
                <ResizablePanel
                  className="relative min-w-[300px]"
                  defaultSize={16}
                  minSize={16}
                  maxSize={16}
                >
                  <Comments />
                </ResizablePanel>
              </>
            )}
          </ResizablePanelGroup>
        )}
        {isProcessing && (
          <CADVersionProcessingHelper
            cadVersionId={cadVersionProcess.cadVersionId}
            status={cadVersionProcess.processingStatus}
            hasNoDownloadUrl={cadVersionProcess.hasNoDownloadUrl}
          />
        )}
      </DocPageContainer>
    </MinimalLayout>
  )
}
